<div class="grid grid-cards-container gap-1.25">
  <div class="main flex flex-col left-container gap-1.25">
    <div class="flex items-center gap-0.9375">
      <app-input
        data-qa="fs-fund-metrics-total-commitment"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.totalCommitment"
        [title]="'Total commitment'"
        [thousandSeparator]="','"
        [separator]="'separator.0'"
        (inputChange)="calculateMetrics($event, metrics.name.totalCommitment)"
        [suffixText]="'100%'"
        (blurEmitter)="emitSaveInputs()">
      </app-input>
      <app-input
        data-qa="fs-fund-metrics-investment"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.investment"
        [title]="'Investment'"
        [thousandSeparator]="','"
        [suffixText]="metricsForm.value.investmentPcnt.toFixed(0) + '%'"
        [separator]="'separator.0'">
      </app-input>
      <div class="flex flex-col gap-[0.25rem]">
        <span class="input-title">Expected expenses</span>
        <div class="flex gap-0.46875">
          <app-input
            data-qa="fs-fund-metrics-expected-expenses"
            class="w-[9.5rem]"
            [formControl]="metricsForm.controls.expectedExpenses"
            [thousandSeparator]="','"
            [separator]="'separator.0'"
            (inputChange)="calculateMetrics($event, metrics.name.expectedExpenses)"
            (blurEmitter)="emitSaveInputs()">
          </app-input>
          <app-input
            data-qa="fs-fund-metrics-expected-expenses-pcnt"
            class="w-[4.5rem]"
            [formControl]="metricsForm.controls.expectedExpensesPcnt"
            [suffix]="'%'"
            [separator]="'separator.2'"
            (inputChange)="calculateMetrics($event, metrics.name.expectedExpensesPcnt)"
            (blurEmitter)="emitSaveInputs()">
          </app-input>
        </div>
      </div>
      <app-input
        data-qa="fs-fund-metrics-unallocated-commitment"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.unAllocatedCommitment"
        [title]="metricsForm.getRawValue().unAllocatedCommitment > 0 ? 'Unallocated commitment' : 'Over commitment'"
        [thousandSeparator]="','"
        [allowNegativeNumbers]="true"
        [suffixText]="metricsForm.value.unAllocatedCommitmentPcnt.toFixed(0) + '%'"
        [separator]="'separator.0'">
      </app-input>
    </div>
    <div class="flex items-center gap-0.9375">
      <app-input
        data-qa="fs-fund-metrics-portfolio-gain"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.portfolioGain"
        [title]="'Portfolio gain/(loss)'"
        [thousandSeparator]="','"
        [allowNegativeNumbers]="true"
        [separator]="'separator.0'">
      </app-input>
      <app-input
        data-qa="fs-fund-metrics-net-gain"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.netGain"
        [title]="'Net gain/(loss)'"
        [thousandSeparator]="','"
        [allowNegativeNumbers]="true"
        [separator]="'separator.0'">
      </app-input>
      <div class="flex flex-col gap-[0.25rem]">
        <span class="input-title">Carried interest</span>
        <div class="flex gap-0.46875">
          <app-input
            data-qa="fs-fund-metrics-carry-interest"
            class="w-[9.5rem]"
            [formControl]="metricsForm.controls.carryInterest"
            [thousandSeparator]="','"
            [separator]="'separator.0'"
            (inputChange)="calculateMetrics($event, metrics.name.carryInterest)"
            (blurEmitter)="emitSaveInputs()">
          </app-input>
          <app-input
            data-qa="fs-fund-metrics-carry-interest-pcnt"
            class="w-[4.5rem]"
            [formControl]="metricsForm.controls.carryInterestPcnt"
            [suffix]="'%'"
            [separator]="'separator.2'"
            (inputChange)="calculateMetrics($event, metrics.name.carryInterestPcnt)"
            (blurEmitter)="emitSaveInputs()">
          </app-input>
        </div>
      </div>
      <app-input
        data-qa="fs-fund-metrics-carry-interest"
        class="w-[13rem]"
        [formControl]="metricsForm.controls.netGainAfterCarry"
        [title]="'Net gain/(loss) after carry'"
        [thousandSeparator]="','"
        [separator]="'separator.0'"
        [allowNegativeNumbers]="true">
      </app-input>
    </div>
  </div>

  <div class="grid grid-cols-3 right-container gap-1.25">
    <div class="main settings-card">
      <span class="font-4 bold500">MOIC</span>
      <span data-qa="fs-settings-cards-moic" class="title-2">
        {{metricsForm.getRawValue().moic | fpModifyValue: 'x' : '' : 2}}
      </span>
    </div>
    <div class="main settings-card">
      <span class="font-4 bold500">Fund multiple</span>
      <span data-qa="fs-settings-cards-fund-multiple" class="title-2">
        {{metricsForm.getRawValue().fundMultiple | fpModifyValue: 'x' : '' : 2}}
      </span>
    </div>
    <div class="main settings-card">
      <span class="font-4 bold500">TVPI (net of carry)</span>
      <span data-qa="fs-settings-cards-tvpi" class="title-2">
        {{metricsForm.getRawValue().tvpi | fpModifyValue: 'x' : '' : 2}}
      </span>
    </div>
    <div class="main settings-card">
      <span class="font-4 bold500">Investment</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-settings-cards-investment" class="title-2">
          {{metricsForm.getRawValue().investment | fpModifyValue}}
        </span>
        <span data-qa="fs-settings-cards-investment-comp-num" class="font-3 bold500 black-8">
          {{companiesNumbers.companiesNumber}} comp.
        </span>
      </div>
    </div>
    <div class="main settings-card">
      <span class="font-4 bold500">Proceed</span>
      <div class="flex items-end justify-between">
        <span data-qa="fs-settings-cards-proceeds" class="title-2">
          {{metricsForm.getRawValue().proceeds | fpModifyValue}}
        </span>
        <span data-qa="fs-settings-cards-proceeds-comp-num" class="font-3 bold500 black-8">
          {{companiesNumbers.exitCompNumber}} comp.
        </span>
      </div>
    </div>
    <div class="main settings-card">
      <span class="font-4 bold500">Portfolio gain</span>
      <span data-qa="fs-settings-cards-portfolio-gain" class="title-2">
        {{metricsForm.getRawValue().portfolioGain | fpModifyValue}}
      </span>
    </div>
  </div>
</div>

